import React from 'react';

import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { setJmrFilter, setTldWarningModalAcknowledged } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import { JmrJobTypes } from 'src/utils/jmrUtils';

interface TldWarningModalProps {
  isOpen: boolean;
  closeModal: VoidFunction;
}

const TldWarningModal = ({ isOpen, closeModal }: TldWarningModalProps) => {
  const dispatch = useAppDispatch();
  const { jmrFilter } = useAppSelector((state) => state.newJmrPage);

  const handleProceed = () => {
    dispatch(setTldWarningModalAcknowledged());
    dispatch(setJmrFilter({ ...jmrFilter, jobType: JmrJobTypes.TLD }));
    closeModal();
  };

  return (
    <Modal
      open={isOpen}
      title="Are you sure TLD is the best match?"
      width="532px"
      onClose={closeModal}
      bodySpacingInset="400"
    >
      <Text type="b300">
        I acknowledge that available process path options (with or without modifications) have been reviewed.
      </Text>
      <ModalFooter>
        <Row spacing="400" alignmentHorizontal="end">
          <Button type="secondary" onClick={closeModal}>
            Go Back
          </Button>
          <Button onClick={handleProceed}>Acknowledge and Proceed</Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default TldWarningModal;
